export default "__VITE_PUBLIC_ASSET__0d861a3f__"